var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alignLeft"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container",staticStyle:{"text-align":"center"}},[_c('i',{staticClass:"fas fa-ban iconSize"}),_c('h2',[_vm._v("Not Permitted")])])])])
}]

export { render, staticRenderFns }